import { isArray } from 'lodash'
import { fieldMixin } from './fieldMixin'

export const navigationPropertyListMixin = {
  mixins: [fieldMixin],
  computed: {
    values: {
      get () {
        return (this.value && isArray(this.value.content)) ? this.value.content : []
      },
      set (values) {
        this.value.content = values
      }
    }
  }
}
